export default __webpack_public_path__ + "static/media/view3_month_age_.20193ec6.csv";